export default __webpack_public_path__ + "static/media/kid.086987e4.jpeg";